import Alpine from "alpinejs";
import { trackEvent } from "../modules/track";

Alpine.magic("trackEvent", () => (obj) => {
    return trackEvent(obj);
});
